// extracted by mini-css-extract-plugin
export default {"About":"About_About__kQoy8","Wave":"About_Wave__0Vgbe","Content":"About_Content__WEeYI","AboutRow":"About_AboutRow__YvnPl","Info":"About_Info__W25fx","Image":"About_Image__WrBti"};